import Client from './Clients/ScrapingToolsClient'

const resource = '/operations/operation_log/'
const resultResource = '/operations/operation_log/result/'

export default {
    get(){
        return Client.get(resource);
    },
    get(id){
        return Client.get(resource+'?id='+id);
    },
    getResult(id){
        return Client.get(resultResource+id+'/');
    },
    getWithJobId(jobId){
        return Client.get(resource+'?job_log='+jobId);
    }
}